var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-global"},[_c('div',{staticClass:"totemBG tw-bg-cover tw-w-screen tw-h-screen tw-flex tw-flex-row"},[_c('div',{staticClass:"tw-flex-1 tw-justify-center tw-items-center tw-self-center tw-place-items-center"},[_c('BoxAgradecimento',{on:{"finish":_vm.finish}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }